<template>
  <div class="flex h-full flex-col px-2 pt-2">
    <div v-for="(item, index) in selectItems" :key="index">
      <template v-if="item.separator === true">
        <Separator />
      </template>

      <template v-else>
        <div
          class="hover:bg-primary-600/10 m-1 flex cursor-pointer items-center gap-3 rounded-md text-gray-400 hover:rounded-md hover:shadow-lg"
          :class="[collapsed ? 'justify-center p-2' : 'justify-start p-2']"
          @click="item.command">
          <component
            :is="item.icon"
            :size="18"
            class="relative transition-all duration-500 ease-in-out"
            v-tooltip="item.label || null"></component>
          <span v-if="!collapsed" class="tracking-wide">{{ item.label }}</span>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import Separator from '@/components/panels/Separator.vue';
import { useAppActionComposable } from '@/composables/useAppActionComposable';
import { useComments } from '@/composables/useComments';
import { PANEL_ICONS } from '@/constants/settingPanels';
const { openNewCommentDialog } = useComments();

defineProps({
  collapsed: {
    type: Boolean,
    default: false,
  },
});

const selectItems = [
  {
    icon: PANEL_ICONS['group'],
    label: 'Group & Arrays',
    command: () => {
      addSceneNode('group');
    },
  },
  {
    label: 'Plane',
    icon: PANEL_ICONS['plane'],
    command: () => {
      addSceneNode('plane');
    },
  },
  {
    icon: PANEL_ICONS['box'],
    label: 'Box',
    command: () => {
      addSceneNode('box');
    },
  },
  {
    label: 'Cylinder',
    icon: PANEL_ICONS['cylinder'],
    command: () => {
      addSceneNode('cylinder');
    },
  },
  {
    label: 'Sphere',
    icon: PANEL_ICONS['sphere'],
    command: () => {
      addSceneNode('sphere');
    },
  },
  {
    label: 'Torus Knot',
    icon: PANEL_ICONS['torusknot'],
    command: () => {
      addSceneNode('torusknot');
    },
  },

  {
    label: 'LED Screen',
    icon: PANEL_ICONS['led_screen'],
    command: () => {
      openLibraryModal('led');
    },
  },
  {
    label: 'Projector',
    icon: PANEL_ICONS['projector'],
    command: () => {
      openLibraryModal('projector');
    },
  },
  {
    label: '3D Model',
    icon: PANEL_ICONS['file'],
    command: () => {
      addModelSceneNode();
    },
  },
  { separator: true },
  {
    label: 'Camera Bookmark',
    icon: PANEL_ICONS['camera_bookmark'],
    command: () => {
      addCameraSceneNode();
    },
  },
  {
    label: 'Annotation',
    icon: PANEL_ICONS['comment'],
    command: () => {
      openNewCommentDialog();
    },
  },
  {
    label: 'Measurement',
    icon: PANEL_ICONS['measurement'],
    command: () => {
      newMeasurement();
    },
  },
];

const { addSceneNode, openLibraryModal, addModelSceneNode, addCameraSceneNode, newMeasurement } =
  useAppActionComposable();
</script>
